export const LOGIN = 'LOGIN'
export const DECREMENT = 'DECREMENT'